import * as types from "../actions/actionTypes";
import getUserIdentification from "../assets/getUserIdentification";
import { updateConsumptionArray } from "../assets/consumption";
const initialState = {
  loading: true,
  data: null,
  premium: [],
  serverInterruptMessage: "",
  completeUserInfoConfirmData: { name: "", show: false },
  completeProjectInfoConfirmData: { name: "", show: false, project: {} },
  accountTitleLevelLoading: false,
  useImprestSequenceLoading: false,
  connectWithApiLoading: false,
  connectToPartnerLoading: false,
  transactionDateLimitLoading: false,
  apiToken: null
};

const Init = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.INIT_SUCCESS:
      const payLoad = action.payLoad;
      if (payLoad.updatePremium) {
        return {
          ...state,
          premium: updateConsumptionArray(state.premium, payLoad.updatePremium),
          loading: false
        };
      }
      if (payLoad.projectData) {
        return {
          ...state,
          data: {
            ...state.data,
            project: { ...state.data.project, ...payLoad.projectData }
          },
          loading: false
        };
      }
      if (payLoad.userData) {
        return {
          ...state,
          data: {
            ...state.data,
            user: payLoad.userData
          },
          loading: false
        };
      }
      if (payLoad.projectSetting) {
        return {
          ...state,
          data: {
            ...state.data,
            project: {
              ...state.data.project,
              serial_accounting_codes: payLoad.projectSetting
            }
          },
          loading: false
        };
      }
      if (payLoad.formSetting) {
        return {
          ...state,
          data: {
            ...state.data,
            form_setting: payLoad.formSetting
          },
          loading: false
        };
      }
      if (payLoad.formValidationSetting) {
        return {
          ...state,
          data: {
            ...state.data,
            form_validation_setting: payLoad.formValidationSetting
          },
          loading: false
        };
      }
      const { message, data, ...initData } = payLoad;
      const { user, premium, ...initData1 } = initData;
      const fullName = getUserIdentification(user);

      return {
        ...state,
        data: { user: { ...user, fullName: fullName }, ...initData1 },
        premium: premium,
        loading: false
      };
    // let payLoad = JSON.parse(JSON.stringify(action.payLoad));
    // if (payLoad.data && payLoad.data.data) {
    //   // let fullName = "";
    //   // if (
    //   //   payLoad.data.data.user.name !== null &&
    //   //   payLoad.data.data.user.family !== null
    //   // ) {
    //   //   payLoad.data.data.user.fullName = `${payLoad.data.data.user.name} ${payLoad.data.data.user.family}`;
    //   // } else {
    //   //   payLoad.data.data.user.fullName = payLoad.data.data.user.phone_number;
    //   // }
    //   payLoad.data.data.user.fullName = getUserIdentification(
    //     payLoad.data.data.user
    //   );
    //   return {
    //     ...state,
    //     data: {
    //       ...{
    //         premium: payLoad.data.premium,
    //         premium_prices: payLoad.data.premium_prices
    //       }
    //     },
    //     ...payLoad
    //   };
    // } else if (payLoad.data && payLoad.data.project_setting) {
    //   return {
    //     ...state,
    //     data: {
    //       ...{
    //         data: {
    //           ...state.data.data,
    //           accounting_codes: payLoad.data.project_setting.accounting_codes,
    //           project: payLoad.data.project_setting.project
    //         },
    //         premium: { ...state.data.premium, ...payLoad.data.premium },
    //         premium_prices: {
    //           ...state.data.premium_prices,
    //           ...payLoad.data.premium_prices
    //         }
    //       }
    //     },
    //     loading: payLoad.loading
    //   };
    // } else if (state.data && payLoad.data && payLoad.data.user) {
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       data: {
    //         ...state.data.data,
    //         user: {
    //           ...payLoad.data.user,
    //           fullName: `${payLoad.data.user.name} ${payLoad.data.user.family}`
    //         }
    //         // fullName: `${payLoad.data.user.name} ${payLoad.data.user.family}`
    //       }
    //     },
    //   };
    // }
    // else if (payLoad.data && payLoad.data.user_counts) {
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       user_counts: payLoad.data.user_counts
    //     },
    //     loading: payLoad.loading
    //   };
    // }
    // else if (payLoad.data && payLoad.data.premium) {
    //   return {
    //     ...state,
    //     data: {
    //       ...state.data,
    //       premium: payLoad.data.premium
    //     },
    //     loading: payLoad.loading
    //   };
    // } else if (
    //   payLoad.data &&
    //   !payLoad.data.premium &&
    //   payLoad.data.project !== null
    // ) {
    //   return { ...state };
    // }

    case types.INIT_FAILURE:
      return { ...state, loading: false, error: action.payLoad };
    case types.INIT_INTERNET_CONNECTION_STATUS:
      return { ...state, ...action.payLoad };
    // case types.INIT_FAILURE:
    //   return { ...state, ...action.payLoad };
    case types.COMPLETE_USER_INFO_CONFIRM_DATA:
      return {
        ...state,
        completeUserInfoConfirmData: { ...action.data, show: true }
      };
    case types.COMPLETE_USER_INFO_CONFIRM_CLOSE:
      return { ...state, completeUserInfoConfirmData: { show: false } };

    case types.COMPLETE_PROJECT_INFO_CONFIRM_DATA:
      return {
        ...state,
        completeProjectInfoConfirmData: { ...action.data, show: true }
      };
    case types.COMPLETE_PROJECT_INFO_CONFIRM_CLOSE:
      return { ...state, completeProjectInfoConfirmData: { show: false } };

    case types.ACCOUNT_TITLE_LEVEL_UPDATE_REQUEST:
      return { ...state, accountTitleLevelLoading: true };
    case types.ACCOUNT_TITLE_LEVEL_UPDATE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            account_title_level: action.data.account_title_level
          }
        },
        accountTitleLevelLoading: false
      };
    case types.ACCOUNT_TITLE_LEVEL_UPDATE_FAILURE:
      return { ...state, accountTitleLevelLoading: false };

    case types.CONNECT_WITH_API_REQUEST:
      return { ...state, connectWithApiLoading: true };
    case types.CONNECT_WITH_API_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            api_token: action.data.data.api_token
          }
        },
        apiToken: action.data.api_token,
        connectWithApiLoading: false
      };
    case types.CONNECT_WITH_API_FAILURE:
      return { ...state, connectWithApiLoading: false };

    case types.CONNECT_TO_PARTNER_REQUEST:
      return { ...state, connectToPartnerLoading: true };
    case types.CONNECT_TO_PARTNER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            connect_to_partners: action.data.connect_to_partners,
            project_users: action.data.project_users
          }
        },
        connectToPartnerLoading: false
      };
    case types.CONNECT_TO_PARTNER_FAILURE:
      return { ...state, connectToPartnerLoading: false };

    case types.PROJECT_TRANSACTION_DATE_LIMIT_REQUEST:
      return { ...state, transactionDateLimitLoading: true };
    case types.PROJECT_TRANSACTION_DATE_LIMIT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            transaction_day_limit: action.data.transaction_day_limit
          }
        },
        transactionDateLimitLoading: false
      };
    case types.PROJECT_TRANSACTION_DATE_LIMIT_FAILURE:
      return { ...state, transactionDateLimitLoading: false };

    case types.USE_IMPREST_SEQUENCE_REQUEST:
      return { ...state, useImprestSequenceLoading: true };
    case types.USE_IMPREST_SEQUENCE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            use_imprest_sequence: action.data.use_imprest_sequence
          }
        },
        useImprestSequenceLoading: false
      };
    case types.USE_IMPREST_SEQUENCE_FAILURE:
      return { ...state, useImprestSequenceLoading: false };

    default:
      return state;
  }
};

export default Init;
